/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Fachliche_Fragen26Inputs */

const en__field_enum_csjensblank_fachliche_fragen26 = /** @type {(inputs: _Field_Enum_Csjensblank_Fachliche_Fragen26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`technical questions`)
};

const de__field_enum_csjensblank_fachliche_fragen26 = /** @type {(inputs: _Field_Enum_Csjensblank_Fachliche_Fragen26Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fachliche Fragen klären`)
};

/**
* | output |
* | --- |
* | "technical questions" |
*
* @param {_Field_Enum_Csjensblank_Fachliche_Fragen26Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_fachliche_fragen26 = /** @type {((inputs?: _Field_Enum_Csjensblank_Fachliche_Fragen26Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Fachliche_Fragen26Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_fachliche_fragen26(inputs)
	return de__field_enum_csjensblank_fachliche_fragen26(inputs)
});
export { _field_enum_csjensblank_fachliche_fragen26 as "_field_enum_CSJENSBLANK_FACHLICHE_FRAGEN" }